import React, { useEffect } from 'react';
import { getPackages } from '../api/packages';
import usePackageStore from '../store/packageStore';
import { AllPackages } from '../components/Packages/AllPackages';
import { FAQ } from '../components/Landing/FAQ';
import { FloatingButton } from '../components/Global';

export const PackagesPage = () => {
  const { setPackages } = usePackageStore();
  
  React.useEffect(() => {
    import('@lottiefiles/lottie-player');
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getPackages();
      setPackages(res);
    };
    fetchData();
  }, [setPackages]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <AllPackages />
      <FloatingButton />
      <FAQ />
    </>
  );
};
